import React from 'react'

export default function Shortcuts() {
  return (
    <div>Shortcuts</div>
  )
}
